import { makeUniqueId } from '@apollo/client/utilities';
import moment from 'moment';
import { Star } from 'react-feather';
import Avatar from '@components/avatar';
import { Link } from 'react-router-dom';

const renderStars = (row) => {
  const q = Array(parseInt(row.rate)).fill();
  const rest = Array(parseInt(5 - q.length)).fill();
  return (
    <span>
      {q.map(() => (
        <Star
          key={makeUniqueId(Date.now())}
          style={{
            marginRight: 4
          }}
          size={15}
          color="#FFCB3C"
          fill="#FFCB3C"
        />
      ))}
      {rest.map(() => (
        <Star
          key={makeUniqueId(Date.now())}
          style={{
            marginRight: 4
          }}
          size={15}
          color="#B9B9C3"
          fill="#B9B9C3"
        />
      ))}
    </span>
  );
};

const renderClient = (row) => {
  return (
    <Avatar
      initials
      className="me-1"
      color={'light-primary'}
      content={row.user.fullName || ''}
    />
  );
};

export const columns = [
  {
    name: 'Fecha',
    sortable: false,
    minWidth: '120px',
    selector: (row) => row.finishedAt,
    cell: (row) => (
      <div>{moment(row.finishedAt).format('DD/MM/YYYY, h:mm a')}</div>
    )
  },
  {
    name: 'USUARIO',
    sortable: false,
    minWidth: '110px',
    selector: (row) => row.cover,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        {renderClient(row)}
        <div className="d-flex flex-column">
          <Link
            to={`/users/view/${row.user._id}`}
            className="user_name text-truncate text-body"
          >
            <span className="fw-bolder">
              {row?.user.fullName || 'No completado'}
            </span>
          </Link>
          <small className="text-truncate text-muted mb-0">
            {row.user.email}
          </small>
        </div>
      </div>
    )
  },
  {
    name: 'COMENTARIOS',
    sortable: true,
    minWidth: '200px',
    sortField: 'comment',
    selector: (row) => row.comment,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder">{row.comment}</span>
        </div>
      </div>
    )
  },
  {
    name: 'CALIFICACION',
    minWidth: '150px',
    sortable: false,
    sortField: 'completed',
    selector: (row) => row.rate,
    cell: (row) => <span className="text-capitalize">{renderStars(row)}</span>
  }
];
